module.exports = __webpack_public_path__ + "static/img/4.16a277c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/1/sp/4.png
// module id = He9F
// module chunks = 0